var map = {
	"./bonbon/bonbon_off.gif": "3137",
	"./clic/clic_off.gif": "c8d8",
	"./clitoris/clitoris_off.gif": "a954",
	"./coeur/coeur_off.gif": "4359",
	"./etoile/etoile_off.gif": "1ae1",
	"./medaille/medaille_off.gif": "a139",
	"./montre/montre_off.gif": "0a74",
	"./neige/neige_off.gif": "5b38",
	"./nuage/nuage_off.gif": "8a03",
	"./pouce/pouce_off.gif": "cd3e",
	"./smiley/smiley_off.gif": "a76e",
	"./stethoscope/stethoscope_off.gif": "f74e",
	"./terre/terre_off.gif": "d1db",
	"./trophee/trophee_off.gif": "ed89"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0b70";